import React from 'react';
import PropTypes from 'prop-types';
// import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const Modal = ({ title, content, open, setOpen }) => {

	const handleClose = () => {
		setOpen(false);
	};

	return (
        <Dialog
            fullWidth
            maxWidth="xl"
            open={Boolean(open)}
            onClose={handleClose}
            aria-labelledby="max-width-dialog-title"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            {/* <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Zatvorite
                </Button> */}
            {/* </DialogActions> */}
        </Dialog>
    )
}

Modal.propTypes = {
    title: PropTypes.string,
    content: PropTypes.any,
    open: PropTypes.bool,
    setOpen: PropTypes.func
}

export default Modal;
